<template>
  <div>
    <div class="container-alb filter-mobile">
      <table
        cellpadding="10"
        cellspacing="0"
        width="95%"
        class="hover-table"
        align="center"
      >
        <tr>
          <td>
            {{ $t("finance.reportTypeLabel") }}
            <br />
            <select class="filtrare width-auto" v-model="report.type">
              <option v-for="type in this.reportTypes" :key="type.id" :value="type.id">
                {{ type.name }}
              </option>
            </select>
          </td>
        </tr>
        <tr>
          <td>
            {{ $t("finance.uploadBankReport") }}
            <form
              @submit.prevent="
                {
                return false;
              }
                "
            >
              <b-form-file v-model="fileReceived" ref="file" accept=".xls"
                    :placeholder="$t('finance.uploadFileLabel')" @input="uploadFile"></b-form-file>
            </form>
          </td>
        </tr>
        <tr>
          <td>
            <a
              class="notification-action custom-notification-action"
              @click="uploadReport()"
              >{{ $t("finance.uploadButtonLabel") }}</a
            >
          </td>
        </tr>
      </table>
      <div class="error-wrapper border-box" v-if="this.reportUploadError">
        <p>{{ this.reportUploadError.description ? this.reportUploadError.description : $t("finance.reportUploadError_" + this.reportUploadError.error_code) }}</p>
      </div>
      <div class="success-wrapper border-box" v-if="this.reportUploadSucces">
        <p>{{ $t("finance.reportUploadSuccess") }}</p>
      </div>
      
    </div>
  </div>
</template>

<script>
  import httpServiceFinance from "@/http/http-finance.js";
  import Cookies from "js-cookie";

  export default {
    props: {
      msg: String,
    },
    data() {
      return {
        reportUploadError: null,
        selectedReportType: null,
        fileReceived: null,
        reportUploadSucces: false,
        reportTypes: [],
        report: {
          content: null,
          name: null,
          type: null,
        },
        error: null,
      };
    },
    methods: {
      productSelected(event) {
        this.filters.product = event.target.value;
        this.searchBeneficiaries();
      },
      isselectedReportType(product) {
        return product === this.filters.product;
      },
      loadReportTypes() {
        httpServiceFinance.financeService
          .getReportTypes(Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {
            if (response.status == 200) {
              this.reportTypes = response.data;
            } else {
              this.reportUploadError = response.data;
            }
          })
      },
      uploadFile() {
        let input = this.$refs.file;

        var reader = new FileReader();
        reader.onload = (e) => {
          if (!e) {
            this.report.content = btoa(reader.content);
          } else {
            this.report.content = btoa(e.target.result);
          }
        };
        let file = input.files;
        if (file && file[0]) {
          this.report.name = file[0].name;
          //For Browsers other than IE.
          if (reader.readAsBinaryString) {
            reader.readAsBinaryString(this.fileReceived);
          } else {
            alert("This browser does not support HTML5.");
          }
        }
        if (!this.fileReceived) {
          return;
        }
        // */
      },
      uploadReport() {
        this.reportUploadError = null;
        this.reportUploadSucces = false;
        if (this.report.content == null) {
          this.reportUploadError = { error_code: "NO_CONTENT" }
          return;
        }
        if (this.report.type == null) {
          this.reportUploadError = { error_code: "NO_TYPE" }
          return;
        }
        httpServiceFinance.financeService
          .uploadBankReport(this.report, Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {
            if (response.status == 200) {
              this.reportUploadSucces = true;
            } else {
              this.reportUploadError = response.data;
            }
            this.fileReceived = null,
            this.report = {
              content: null,
              name: null,
              type: null,
            };
          })
      },
      selectProduct(index) {
        this.selectedReportType = this.cardProducts[index];
      },
    },
    created() {
      this.loadReportTypes();
    },
  };
</script>

<style scoped src="@/assets/styles/beneficiary.css"></style>
<style>
.error-wrapper {
  color: #c61b10
}

.success-wrapper {
  color: #7ea800
}


</style>
